import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert,
  IconButton,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SyncIcon from '@mui/icons-material/Sync';

interface ResoMediaDialogProps {
  open: boolean;
  onClose: () => void;
  onFetchMedia: () => void;
  isFetching?: boolean;
}

export const ResoMediaDialog: React.FC<ResoMediaDialogProps> = ({
  open,
  onClose,
  onFetchMedia,
  isFetching = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isFetching ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="reso-media-dialog-title"
    >
      <DialogTitle
        id="reso-media-dialog-title"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        Media Out of Sync
        {!isFetching && onClose && (
          <IconButton
            onClick={onClose}
            size="small"
            aria-label="close"
            disabled={isFetching}
          >
            <CloseIcon />
          </IconButton>
        )}
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning" sx={{ mb: 2 }}>
          Your media files are out of sync with the server
        </Alert>

        <DialogContentText>
          The media information stored locally doesn&apos;t match what&apos;s on
          the server.
        </DialogContentText>

        <DialogContentText sx={{ mt: 2 }}>
          Fetching media from the server will refresh all media files but some
          changes may have been lost.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={isFetching} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={onFetchMedia}
          variant="contained"
          color="primary"
          disabled={isFetching}
          startIcon={isFetching ? <CircularProgress size={16} /> : <SyncIcon />}
        >
          {isFetching ? 'Fetching...' : 'Fetch Media'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
